import { render, staticRenderFns } from "./PStyles.vue?vue&type=template&id=204c2a04&"
import script from "./PStyles.vue?vue&type=script&lang=js&"
export * from "./PStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports